import React from 'react'

import { useTranslation } from 'react-i18next'

import ExternalLink from '@components/shared/ExternalLink'
import { DiscussionEvent } from '@custom-types/activity'
import { formatRelativeTime } from '@utils/formatters/date.formatter'
import PageRoutes from '@utils/page-routes'

interface Props {
  event: DiscussionEvent
}

const DiscussionActivity: React.FC<Props> = ({ event }: Props) => {
  const { t } = useTranslation()
  const { actor, action, actionTarget } = event
  return (
    <div className="ml-3 flex-1 flex flex-row items-center">
      <span className="flex-1 flex flex-row items-center break-words">
        <ExternalLink
          className="underline-link mr-1 flex flex-row items-center"
          href={PageRoutes.userProfilePath(actor.external_id)}>
          {actor.username}
        </ExternalLink>
        {t(`event.${action}`)}
        <ExternalLink
          className="underline-link ml-1 flex flex-row items-center"
          href={
            actionTarget.forum?.group_id
              ? PageRoutes.viewGroupDiscussionPath(
                  actionTarget.forum.group_id,
                  actionTarget.forum.id,
                  actionTarget.id
                )
              : PageRoutes.viewDiscussionPath(actionTarget.forum_id, actionTarget.id)
          }>
          {actionTarget.name}
        </ExternalLink>
      </span>
      <span className="text-gray-text dark:text-gray-text-dm pl-2.5 text-xs whitespace-nowrap">
        {formatRelativeTime(event.when, new Date())}
      </span>
    </div>
  )
}

export default DiscussionActivity
